import { CardContainerContextProvider } from 'crm-cards-sdk/internal/CardContainerContext';
import TileCardFormatter from 'crm-cards-sdk/card-formatters/TileCardFormatter';
import { createContainerContentKey } from './createContainerContentKey';
import { ColumnWrapper } from 'foundations-components/transitional/components/ColumnWrapper';
import { ColumnSpreads } from 'foundations-components/transitional/components/ColumnSpreads';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ColumnsContainerFormatter({
  containerId,
  contents,
  CrmContainerContentRenderer,
  observerManager,
  CardFormatter = TileCardFormatter
}) {
  return /*#__PURE__*/_jsx(CardContainerContextProvider, {
    value: {
      DefaultCardFormatter: CardFormatter,
      reorderable: false,
      observerManager
    },
    children: /*#__PURE__*/_jsx(ColumnWrapper, {
      gap: "500",
      children: contents.map((column, index) => {
        return /*#__PURE__*/_jsx(ColumnSpreads, {
          children: /*#__PURE__*/_jsx(CrmContainerContentRenderer, {
            content: column
          })
        }, createContainerContentKey(containerId, column, index));
      })
    })
  });
}